'use es6';

import MAB from '../models/MAB';
import { RECEIVED_MAB, REQUESTED_MAB_FAILED, REQUESTED_MAB } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new MAB(), action) => {
  switch (action.type) {
    case REQUESTED_MAB:
      return state.set('status', RequestStatus.PENDING);

    case RECEIVED_MAB:
      return action.payload.mab;

    case REQUESTED_MAB_FAILED:
      return state.set('status', RequestStatus.FAILED);

    default:
      return state;
  }
});